/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'

import { PaginationFooterPropsV2 } from './Models'

export const useControllerPaginationFooterV2 = ({
  limit,
  offset,
  page,
  setPage,
  total,
}: PaginationFooterPropsV2) => {
  const [inputPage, setInputPage] = React.useState('1')

  React.useEffect(() => {
    setInputPage(`${page}`)
  }, [page])

  function paginRange() {
    const off = offset + 1

    let maxRange = offset + limit

    if (total) {
      if (maxRange > total) {
        maxRange = total
      }
      return `${off} - ${maxRange} de ${total}`
    }

    return `${off} - ${maxRange}`
  }

  function maxPage() {
    if (total) {
      const max = total / limit
      if (max % 1 !== 0) {
        const decimal = max % 1
        const maxInt = max - decimal + 1
        return maxInt
      }

      return max
    }
    return 0
  }

  function paginMax() {
    if (total) {
      return `Página ${inputPage} de ${maxPage()}`
    }

    return `Página ${inputPage}`
  }

  function changePageInput(s: string) {
    const newString = s.replace(/\D/g, '')

    setInputPage(newString)
    if (setPage) setPage(newString)
  }

  return {
    paginRange,
    inputPage,
    changePageInput,
    paginMax,
  }
}
